export default __webpack_public_path__ + "static/media/DB_7.757b74a9.png";